import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const TEST_TOKEN_KEY = "impactvest_test_token";

export function getTestToken() {
  return localStorage.getItem(TEST_TOKEN_KEY);
}
export function setTestToken(token) {
  if (token) localStorage.setItem(TEST_TOKEN_KEY, token);
  else localStorage.removeItem(TEST_TOKEN_KEY);
}

export const testApi = axios.create({ baseURL: API });

testApi.interceptors.request.use((cfg) => {
  const t = getTestToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

testApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) setTestToken(null);
    return Promise.reject(err);
  }
);

// Fire-and-forget analytics event; failure is silent.
export function recordEvent(event, meta = {}) {
  if (!getTestToken()) return;
  testApi.post("/test/events", { event, meta }).catch(() => {});
}
